import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const workInstructionModule = {
  namespaced: true,
  state() {
    return {
      workInstructionPackages: [],
      currentWorkInstructionPackage: null,
      currentWorkInstruction: [],
    };
  },
  actions,
  getters,
  mutations,
};

export default workInstructionModule;
